{
  "pages": {
    "invoices": {
      "title": "Factures"
    },
    "payments": {
      "title": "Paiements"
    },
    "taxes": {
      "title": "Taxes"
    },
    "assets": {
      "title": "Immobilisations"
    },
    "auditTrail": {
      "title": "Piste d'audit finance"
    },
    "accounting": {
      "title": "Comptabilité"
    },
    "workflowDesigner": {
      "title": "Concepteur de workflow"
    },
    "workflows": {
      "title": "Workflows et recouvrements"
    },
    "treasury": {
      "title": "Trésorerie"
    },
    "cashForecast": {
      "title": "Prévision de trésorerie"
    },
    "setup": {
      "title": "Configuration finance"
    },
    "revenue": {
      "title": "Comptabilisation des revenus"
    },
    "reports": {
      "title": "Rapports financiers",
      "profitLoss": "Compte de résultat",
      "balanceSheet": "Bilan",
      "cashFlow": "Flux de trésorerie",
      "arAging": "Balance âgée clients",
      "apAging": "Balance âgée fournisseurs"
    },
    "reportBuilder": {
      "title": "Générateur de rapports"
    },
    "payables": {
      "title": "Comptes fournisseurs"
    },
    "ledger": {
      "title": "Grand livre"
    },
    "documentCapture": {
      "title": "Capture de documents (OCR)"
    },
    "integrations": {
      "title": "État des intégrations"
    },
    "expenses": {
      "title": "Dépenses"
    },
    "compliance": {
      "title": "Conformité internationale"
    },
    "collections": {
      "title": "Centre de recouvrement"
    },
    "banking": {
      "title": "Banque et rapprochement"
    },
    "budgets": {
      "title": "Budgets et écarts"
    },
    "automation": {
      "title": "Centre d'automatisation financière"
    },
    "analytics": {
      "title": "Analyses entreprise"
    },
    "setupWizard": {
      "title": "Assistant de configuration finance"
    },
    "healthCenter": {
      "title": "Centre de santé finance"
    },
    "closeCenter": {
      "title": "Clôture financière"
    },
    "businessRules": {
      "title": "Règles métier"
    },
    "dashboard": {
      "title": "Vue d'ensemble finance",
      "description": "Trésorerie, revenus et santé financière — vue exécutive selon vos droits finance",
      "noIssues": "Aucun problème ouvert — vos comptes sont en bonne santé.",
      "continueSetup": "Continuer l'assistant de configuration",
      "healthCenter": "Centre de santé",
      "setupProgress": "{{completed}}/{{total}} étapes de configuration",
      "setupIncomplete": "La configuration finance est incomplète ({{progress}}).",
      "finishSetup": "Terminer la configuration guidée",
      "setupIncompleteSuffix": "pour débloquer les contrôles de mise en production et la clôture.",
      "viewAllInHealthCenter": "Tout voir dans le centre de santé"
    },
    "chartOfAccountsJournalComposerMulti": "Chart of accounts, journal composer, multi-stage approbation, draft → approve → post",
    "amountThresholdsApprovalRoutingAndAutomation": "Amount thresholds, approbation routing, et automation triggers",
    "monthQuarterAndYearEndClose": "Month, quarter, et year-end close checklist avec task owners et dependencies",
    "automaticChecksForIssuesThatAffect": "Automatic checks pour issues that affect votre books, cash, et compliance",
    "getYourBooksReadyInNine": "Get votre books ready in nine guided steps — no accounting degree requis",
    "revenueAccounts": "Comptes de revenus",
    "expenseAccounts": "Comptes de charges",
    "arAging": "Balance âgée clients",
    "apAging": "Balance âgée fournisseurs",
    "revenueExpensesAndAgingAnalyticsDrill": "Revenue, expenses, et aging analytics — drill-down without accounting complexity",
    "activeAssetsDepreciationMethodAndBatch": "Active assets, depreciation method, et batch depreciation run",
    "whoChangedWhatWhenWithIp": "Who changed what, when — avec IP, device, et before/after snapshots",
    "noAuditEntriesYetChangesTo": "No audit entries yet. Changes à rules, documents, et compliance are tracked automatically.",
    "recurringJournalsRevenueRecognitionDunningAnd": "Recurring journals, revenue recognition, dunning, et depreciation — run manually ou on schedule",
    "importStatementsAutoMatchAndManually": "Import statements, auto-match, et manually reconcile bank transactions",
    "annualAndDepartmentalBudgetsWithLive": "Annual et départemental budgets avec live variance against actual GL",
    "totalOverdue": "Total en retard",
    "openReceivables": "Créances ouvertes",
    "overdueInvoices": "Overdue factures",
    "openPromises": "Promesses ouvertes",
    "openDisputes": "Litiges ouverts",
    "overdueReceivablesDunningPromisesToPay": "Overdue receivables, dunning, promises à pay, et dispute tracking",
    "countryTaxPacksForGstVat": "Country tax packs pour GST, VAT, sales tax, et withholding",
    "financialHealth": "Santé financière",
    "businessHealth": "Santé de l'entreprise",
    "cashPosition": "Position de trésorerie",
    "revenueMtd": "Revenu (mois en cours)",
    "profitMtd": "Bénéfice (mois en cours)",
    "pendingApprovals": "Pending approbations",
    "recommendations": "Recommandations",
    "topIssues": "Principaux problèmes",
    "expenseClaimsAndApprovalsApprovedExpenses": "Expense claims et approbations — approuvé expenses post à le general ledger",
    "pendingAccountingEvents": "Événements comptables en attente",
    "unreconciledBankTxns": "Transactions bancaires non rapprochées",
    "failedAutomations24h": "Automatisations échouées (24 h)",
    "accountingEventsApprovalsAndBankReconciliation": "Accounting events, approbations, et bank reconciliation status across connected modules",
    "createCustomerInvoicesPreviewAndEmail": "Create client factures, preview, et email PDF à clients",
    "trialBalanceAndAccountingEventDrill": "Trial balance et accounting event drill-down — source document → event → journal → ledger",
    "uploadVendorBillsAndReceiptsExtract": "Upload vendor bills et receipts — extract fields, review, then post",
    "openVendorPayablesAndBatchPayment": "Open vendor payables et batch paiement runs",
    "customerReceiptsArAndAccountsPayable": "Client receipts (AR) et accounts payable vendor directory",
    "saveAndRunCustomFinancialReport": "Save et run custom financial rapport definitions",
    "consolidationSummary": "Synthèse de consolidation",
    "pLBalanceSheetCashFlow": "P&L, balance sheet, cash flow, AR aging — PDF et Excel export",
    "deferredRevenueSchedulesAndAsc606": "Deferred revenue schedules et ASC 606 straight-line recognition",
    "fiscalPeriodsBudgetsVarianceAndChart": "Fiscal periods, budgets, variance, et chart of accounts",
    "whatDoYouWantToDo": "What do you want à do?",
    "taxCodesTaxGroupsAndLive": "Tax codes, tax groups, et live tax calculation",
    "openingCash": "Trésorerie initiale",
    "expectedInflows": "Entrées attendues",
    "expectedOutflows": "Sorties attendues",
    "projectedClosing": "Clôture projetée",
    "expectedCashInAndOutBy": "Expected cash in et out by period — based on open receivables et payables due dates",
    "bankAccounts": "Bank comptes",
    "unreconciledTxns": "Transactions non rapprochées",
    "openPayables": "Dettes fournisseurs ouvertes",
    "netLiquidity": "Liquidité nette",
    "cashPositionLiquidityBankReconciliationStatus": "Cash position, liquidity, bank reconciliation status, et forecast",
    "configureMultiStageApprovalWorkflowsFor": "Configure multi-stage approbation flux de travails pour finance documents",
    "configurableApprovalWorkflowsAndArDunning": "Configurable approbation flux de travails et AR dunning",
    "billCustomersCollectPaymentsAndManage": "Bill clients, collect paiements, et manage collections — no accounting jargon requis",
    "configureTaxCodesAndCalculateTax": "Configure tax codes et calculate tax on transactions",
    "payVendorsManageExpensesAndRun": "Pay vendors, manage expenses, et run paiement batches — we post à le ledger pour you",
    "setupCloseHealthWorkflowsAndPlatform": "Setup, close, health, flux de travails, et platform governance",
    "configurableFinanceWorkspace": "Espace finance configurable avec comptabilité en partie double auditée, prise en charge multidevise et fonctionnalités entreprise selon l'abonnement.",
    "businessHealthScore": "Score de santé métier",
    "setupProgress": "Progression : {{completed}} / {{total}} étapes",
    "scheduleLabel": "Planification : {{schedule}}",
    "manual": "Manuel",
    "levelNumber": "Niveau {{level}}",
    "afterDaysOverdue": "Après {{days}} jours de retard",
    "vendorSelfService": "Libre-service fournisseur :",
    "activeCompliancePacks": "Actif : {{packs}}",
    "overallStatus": "Statut global : {{status}}",
    "oneYear": "1 an",
    "daysCount": "{{days}} jours",
    "cashShortageAlert": "Alerte de trésorerie — la trésorerie de clôture projetée est négative. Consultez les dettes fournisseurs et les recouvrements."
  },
  "links": {
    "invoiceArrow": "Facture →",
    "configureWorkflowsArrow": "Configurer les workflows →",
    "openVendorPortal": "Ouvrir le portail fournisseur",
    "accountingEventsArrow": "Événements comptables →",
    "approvalsArrow": "Approbations →",
    "bankReconciliationArrow": "Rapprochement bancaire →",
    "backToTreasury": "← Retour à la trésorerie"
  },
  "workspaces": {
    "receivables": "Créances",
    "tax": "Fiscalité",
    "payables": "Dettes fournisseurs",
    "administration": "Gestion"
  },
  "breadcrumbs": {
    "finance": "Finances",
    "administration": "Gestion",
    "auditTrail": "Piste d'audit",
    "reports": "Rapports",
    "builder": "Générateur",
    "rules": "Règles",
    "close": "Clôture",
    "documentCapture": "Capture de documents",
    "workflows": "Flux de travails",
    "designer": "Concepteur",
    "health": "Santé",
    "setupWizard": "Assistant de configuration",
    "analytics": "Analyses",
    "automation": "Automatisation",
    "receivables": "Créances",
    "collections": "Recouvrements",
    "tax": "Fiscalité",
    "compliance": "Conformité",
    "integrations": "Intégrations",
    "treasury": "Trésorerie",
    "forecast": "Prévision",
    "ledger": "Grand livre"
  },
  "headings": {
    "captureDocument": "Capturer un document",
    "existingWorkflows": "Workflows existants",
    "createUpdateWorkflow": "Créer / mettre à jour un workflow",
    "approvalStages": "Étapes d'approbation",
    "savedReports": "Rapports enregistrés",
    "newReport": "Nouveau rapport",
    "preview": "Aperçu",
    "newRule": "Nouvelle règle",
    "activeRules": "Règles actives",
    "startNewClose": "Démarrer une nouvelle clôture",
    "closeRuns": "Clôtures",
    "closeChecklist": "Checklist de clôture",
    "fiscalPeriods": "Périodes fiscales",
    "budgetsForYear": "Budgets ({{fiscalYear}})",
    "budgetVsActual": "Budget vs réel",
    "chartOfAccounts": "Plan comptable",
    "critical": "Critique",
    "warnings": "Avertissements",
    "information": "Informations",
    "recentRuns": "Exécutions récentes",
    "collectionQueue": "File de recouvrement",
    "dunningLevels": "Niveaux de relance",
    "connectedModules": "Modules connectés"
  },
  "tableHeaders": {
    "file": "Fichier",
    "vendor": "Fournisseur",
    "invoiceNumber": "N° de facture",
    "amount": "Montant",
    "status": "Statut",
    "stage": "Étape",
    "role": "Rôle",
    "when": "Quand",
    "entity": "Entité",
    "action": "Opération",
    "actor": "Acteur",
    "ip": "IP",
    "reason": "Motif",
    "total": "Total",
    "task": "Tâche",
    "ownerRole": "Rôle propriétaire",
    "code": "Code",
    "start": "Début",
    "end": "Fin",
    "account": "Compte",
    "planned": "Prévu",
    "actual": "Réel",
    "variance": "Écart",
    "job": "Poste",
    "started": "Démarré",
    "customer": "Client",
    "daysOverdue": "Jours de retard",
    "promise": "Promesse",
    "period": "Période",
    "inflows": "Entrées",
    "outflows": "Sorties",
    "net": "Net",
    "cumulative": "Cumulé"
  },
  "emptyStates": {
    "noCapturedDocuments": "Aucun document capturé. Collez le texte de la facture ci-dessus pour extraire automatiquement le fournisseur, le montant et la date.",
    "noWorkflowsYet": "Aucun workflow pour le moment.",
    "noCustomReportsYet": "Aucun rapport personnalisé pour le moment.",
    "runSavedReportToPreview": "Exécutez un rapport enregistré pour prévisualiser les résultats.",
    "noBusinessRulesConfigured": "Aucune règle métier configurée pour le moment.",
    "noCloseRunsYet": "Aucune clôture pour le moment.",
    "selectOrStartCloseRun": "Sélectionnez ou démarrez une clôture pour voir les tâches.",
    "noPeriodsSeeded": "Aucune période - la configuration finance initialise l'année fiscale à la première utilisation.",
    "createBudgetForVariance": "Créez un budget avec des lignes de compte pour voir les écarts.",
    "noCriticalIssues": "Aucun problème critique",
    "noWarnings": "Aucun avertissement",
    "nothingToNote": "Rien à signaler",
    "noAutomationRunsYet": "Aucune exécution d'automatisation pour le moment.",
    "noOverdueReceivables": "Aucune créance en retard — excellent travail !",
    "noCompliancePackActivated": "Aucun pack de conformité activé. Choisissez un pack pays ci-dessous pour configurer la validation fiscale."
  },
  "placeholders": {
    "documentFileName": "facture-acme-1042.pdf"
  },
  "buttons": {
    "extracting": "Extraction...",
    "extractAndQueueForReview": "Extraire et mettre en file de revue",
    "backToWorkflows": "Retour aux workflows",
    "remove": "Supprimer",
    "addStage": "Ajouter une étape",
    "saveWorkflow": "Enregistrer le workflow",
    "refresh": "Actualiser",
    "standardReports": "Rapports standard",
    "run": "Exécuter",
    "complete": "Terminer",
    "newBudget": "Nouveau budget",
    "createQuickInvoice": "Créer une facture rapide",
    "recordQuickPayment": "Enregistrer un paiement rapide",
    "addBankAccount": "Ajouter un compte bancaire",
    "openSettings": "Ouvrir les paramètres",
    "markStepComplete": "Marquer l'étape terminée",
    "nextStep": "Étape suivante",
    "runNow": "Exécuter maintenant",
    "running": "Exécution…",
    "activate": "Activer"
  },
  "options": {
    "documentTypes": {
      "VENDOR_BILL": "Facture fournisseur",
      "RECEIPT": "Reçu",
      "TAX_DOCUMENT": "Document fiscal",
      "BANK_STATEMENT": "Relevé bancaire",
      "EXPENSE_RECEIPT": "Reçu de dépense"
    },
    "entityTypes": {
      "JOURNAL_ENTRY": "Écriture de journal",
      "EXPENSE": "Dépense",
      "PAYMENT_RUN": "Lot de paiement",
      "INVOICE": "Facture"
    },
    "routingTypes": {
      "SEQUENTIAL": "Séquentiel",
      "PARALLEL": "Parallèle"
    },
    "baseReports": {
      "accountBalancesByType": "Soldes des comptes (par type)",
      "profitLossFiltered": "Compte de résultat (filtré)",
      "balanceSheetFiltered": "Bilan (filtré)",
      "cashFlowFiltered": "Flux de trésorerie (filtré)",
      "arAgingFiltered": "Ancienneté clients (filtrée)"
    },
    "businessRuleEntityTypes": {
      "invoice": "Facture",
      "payment": "Paiement",
      "journal": "Journal"
    },
    "closeTypes": {
      "monthEnd": "Fin de mois",
      "quarterEnd": "Fin de trimestre",
      "yearEnd": "Fin d'année"
    }
  },
  "defaults": {
    "managerReview": "Revue manager",
    "operatingBudgetName": "Exploitation {{fiscalYear}}",
    "mainBank": "Banque principale"
  },
  "dialogs": {
    "matchTransaction": "Rapprocher la transaction"
  },
  "statuses": {
    "locked": "VERROUILLÉ"
  },
  "loading": "Chargement...",
  "workspaceCards": {
    "receivables": {
      "guidance": "Créez une facture, envoyez-la au client et enregistrez les paiements lorsqu'ils arrivent. La comptabilité est générée automatiquement.",
      "invoices": "Créer, prévisualiser et envoyer des factures client",
      "customerPayments": "Paiements client",
      "payments": "Enregistrer l'argent reçu des clients",
      "collections": "Créances en retard, relances et promesses de paiement",
      "arAgingReport": "Rapport d'ancienneté clients",
      "arAging": "Voir qui vous doit de l'argent et depuis combien de temps"
    },
    "tax": {
      "taxCodes": "Codes fiscaux",
      "taxCodesDesc": "Configuration taxe de vente, TVA et GST",
      "compliance": "Packs fiscaux pays et validations",
      "setupWizard": "Configuration fiscale guidée pendant l'onboarding",
      "taxReports": "Rapports fiscaux",
      "reports": "Consulter les rapports financiers liés aux taxes"
    },
    "payables": {
      "guidance": "Enregistrez les factures fournisseur, approuvez les dépenses et planifiez les paiements. Les écritures comptables sont créées automatiquement à la comptabilisation.",
      "apRuns": "Fournisseurs et paiements",
      "apRunsDesc": "Factures fournisseur, lots de paiement et rapprochement à 3 voies",
      "documents": "OCR des factures fournisseur et reçus avant comptabilisation",
      "employeeExpenses": "Dépenses employés",
      "expenses": "Soumettre, approuver et rembourser les dépenses",
      "vendorPortal": "Portail fournisseur",
      "portal": "Libre-service fournisseur pour commandes, factures et paiements"
    },
    "admin": {
      "setupWizard": "Configuration finance guidée initiale",
      "health": "Problèmes, avertissements et corrections en un clic",
      "close": "Checklist de clôture mensuelle, trimestrielle et annuelle",
      "automation": "Tâches planifiées et exécutions manuelles",
      "integrations": "Statut des événements comptables intermodules",
      "audit": "Qui a modifié quoi, quand et pourquoi",
      "setup": "Plan comptable, périodes fiscales et budgets",
      "approvalWorkflows": "Workflows d'approbation",
      "workflowDesc": "Configurer qui approuve quoi",
      "rules": "Règles d'approbation IF/THEN sans code",
      "usersSubscription": "Utilisateurs et abonnement",
      "usersSubscriptionDesc": "Administration du module (plateforme)"
    }
  },
  "toast": {
    "journalPosted": "Journal comptabilisé",
    "accountCreated": "Compte créé",
    "journalDraftCreated": "Brouillon de journal créé",
    "periodLocked": "Période verrouillée",
    "periodReopened": "Période rouverte",
    "dunningSent": "{{count}} relances envoyées",
    "reportExported": "{{reportType}} exporté en {{format}}",
    "consolidationClosed": "Consolidation {{runNumber}} clôturée ({{status}})",
    "taxCreated": "Taxe créée",
    "stepComplete": "{{stepName}} marquée terminée",
    "financeLive": "La finance est opérationnelle !",
    "invoiceSent": "Facture envoyée à {{email}}",
    "reportSaved": "Rapport enregistré",
    "paymentRecorded": "Paiement enregistré",
    "ruleSaved": "Règle enregistrée",
    "budgetCreated": "Budget créé",
    "workflowSaved": "Workflow enregistré",
    "paymentRunCreated": "Lot de paiement créé à partir des dettes ouvertes",
    "paymentRunPosted": "Lot de paiement comptabilisé",
    "closeRunStarted": "Clôture démarrée ({{closeType}})",
    "taskCompleted": "Tâche terminée : {{taskName}}",
    "deferredScheduleCreated": "Échéancier de revenus différés créé",
    "recognizedLines": "{{count}} lignes d'échéancier comptabilisées",
    "depreciationComplete": "Amortissement terminé ({{count}} journaux comptabilisés)",
    "importedTransactions": "{{count}} transactions importées",
    "importedOfx": "{{count}} transactions OFX importées",
    "importedMt940": "{{count}} transactions MT940 importées",
    "bankFeedConfigured": "Flux bancaire configuré",
    "autoMatched": "{{count}} transactions rapprochées automatiquement",
    "reconciliationFinalized": "Rapprochement finalisé ({{status}}) pour le {{date}}",
    "invoiceCreated": "Facture créée"
  },
  "errors": {
    "journalApprovalOnly": "Seules les écritures de journal ont un workflow d'approbation",
    "accountCodeNameRequired": "Le code et le nom du compte sont requis",
    "journalAccountsAmount": "Sélectionnez des comptes et saisissez un montant positif",
    "postFailed": "Échec de la comptabilisation",
    "createAccountFailed": "Échec de la création du compte",
    "createJournalFailed": "Échec de la création du journal",
    "loadFiscalPeriods": "Échec du chargement des périodes fiscales",
    "lockPeriodFailed": "Échec du verrouillage de la période",
    "reopenPeriodFailed": "Échec de la réouverture de la période",
    "createBudgetFailed": "Échec de la création du budget",
    "loadWorkflows": "Échec du chargement des workflows",
    "dunningRunFailed": "Échec de la relance",
    "loadProfitLoss": "Échec du chargement du compte de résultat",
    "loadBalanceSheet": "Échec du chargement du bilan",
    "loadCashFlow": "Échec du chargement des flux de trésorerie",
    "loadArAging": "Échec du chargement de l'ancienneté créances",
    "exportFailed": "Échec de l'export",
    "fiscalYearPeriodRequired": "Saisissez une année fiscale et une période valides",
    "consolidationCloseFailed": "Échec de la clôture de consolidation",
    "loadTaxes": "Échec du chargement des taxes",
    "taxCalculationFailed": "Échec du calcul fiscal",
    "taxCodeNameRequired": "Le code et le nom de la taxe sont requis",
    "createTaxFailed": "Échec de la création de la taxe",
    "loadWizard": "Échec du chargement de l'assistant",
    "saveProgressFailed": "Échec de l'enregistrement de la progression",
    "recipientEmailRequired": "Saisissez l'e-mail du destinataire",
    "loadInvoicePreview": "Échec du chargement de l'aperçu de facture",
    "sendInvoiceFailed": "Échec de l'envoi de la facture",
    "loadReports": "Échec du chargement des rapports",
    "saveReportFailed": "Échec de l'enregistrement du rapport",
    "runReportFailed": "Échec de l'exécution du rapport",
    "customerAmountRequired": "Sélectionnez un client et saisissez un montant valide",
    "recordPaymentFailed": "Échec de l'enregistrement du paiement",
    "loadRules": "Échec du chargement des règles",
    "saveRuleFailed": "Échec de l'enregistrement de la règle",
    "budgetCodeNameRequired": "Le code et le nom du budget sont requis",
    "createBudgetFailedShort": "Échec de la création du budget",
    "workflowFieldsRequired": "Le code, le nom et au moins une étape sont requis",
    "saveWorkflowFailed": "Échec de l'enregistrement du workflow",
    "loadApData": "Échec du chargement des données fournisseurs",
    "createPaymentRunFailed": "Échec de la création du lot de paiement",
    "loadCloseRuns": "Échec du chargement des clôtures",
    "loadTasks": "Échec du chargement des tâches",
    "startCloseFailed": "Échec du démarrage de la clôture",
    "completeTaskFailed": "Échec de la finalisation de la tâche",
    "loadDeferredRevenue": "Échec du chargement des revenus différés",
    "validAmountRequired": "Saisissez un montant valide",
    "createFailed": "Échec de la création",
    "recognitionRunFailed": "Échec de la comptabilisation",
    "loadAssets": "Échec du chargement des immobilisations",
    "depreciationRunFailed": "Échec de l'amortissement",
    "loadBankAccounts": "Échec du chargement des comptes bancaires",
    "loadUnmatched": "Échec du chargement des transactions non rapprochées",
    "importFailed": "Échec de l'import",
    "ofxImportFailed": "Échec de l'import OFX",
    "mt940ImportFailed": "Échec de l'import MT940",
    "saveFeedConfigFailed": "Échec de l'enregistrement du flux bancaire",
    "autoMatchFailed": "Échec du rapprochement automatique",
    "manualMatchFailed": "Échec du rapprochement manuel",
    "statementDateBalanceRequired": "Saisissez une date de relevé et un solde valides",
    "finalizeReconciliationFailed": "Échec de la finalisation du rapprochement",
    "invoiceTotalRequired": "Le total de la facture doit être supérieur à zéro",
    "lineItemRequired": "Ajoutez au moins une ligne",
    "customerEmailRequired": "Sélectionnez un client pour envoyer la facture par e-mail",
    "createInvoiceFailed": "Échec de la création de la facture",
    "pdfDownloadFailed": "Échec du téléchargement PDF",
    "printFailed": "Échec de l'impression",
    "loadAuditTrail": "Échec du chargement de la piste d'audit",
    "createExpenseFailed": "Échec de la création de la dépense",
    "loadAutomation": "Échec du chargement de l'automatisation",
    "jobRunFailed": "Échec de l'exécution du job",
    "loadCashForecast": "Échec du chargement de la prévision de trésorerie",
    "loadTreasury": "Échec du chargement de la trésorerie",
    "loadTrialBalance": "Échec du chargement de la balance",
    "loadCollections": "Échec du chargement des recouvrements",
    "loadCompliance": "Échec du chargement de la conformité",
    "activationFailed": "Échec de l'activation",
    "loadDocuments": "Échec du chargement des documents",
    "captureFailed": "Échec de la capture",
    "loadIntegrationHealth": "Échec du chargement de l'état des intégrations",
    "loadHealthCenter": "Échec du chargement du centre de santé",
    "loadAnalytics": "Échec du chargement des analyses",
    "failedToLoadAccounts": "Échec du chargement de accounts",
    "failedToLoadJournals": "Échec du chargement de journals",
    "failedToLoadPayments": "Échec du chargement de payments",
    "failedToLoadExpenses": "Échec du chargement de expenses",
    "failedToLoadInvoices": "Échec du chargement de invoices",
    "failedToLoadAccountingEvents": "Échec du chargement de accounting events"
  },
  "invoicePreview": "Aperçu de la facture",
  "labels": {
    "accountCode": "Compte code",
    "accountName": "Compte name",
    "description": "Descriptif",
    "ruleCode": "Règle code",
    "ruleName": "Nom de la règle",
    "entityType": "Type d'entité",
    "amountThreshold": "Seuil de montant",
    "approverRole": "Rôle d'approbateur",
    "closeType": "Type de clôture",
    "fiscalYear": "Exercice fiscal",
    "period": "Période",
    "statementDate": "Date du relevé",
    "statementBalance": "Solde du relevé",
    "feedType": "Type de flux",
    "feedName": "Nom du flux",
    "selectBankAccount": "Select bank compte",
    "budgetCode": "Code budgétaire",
    "budgetName": "Nom du budget",
    "customer": "Client",
    "invoiceOptional": "Facture # (optional)",
    "invoiceDate": "Facture date",
    "dueDate": "Date d'échéance",
    "currency": "Devise",
    "discount": "Remise",
    "notesShownOnInvoice": "Notes (shown on facture)",
    "selectCustomer": "Select client",
    "autoGeneratedIfBlank": "Généré automatiquement si vide",
    "serviceOrProduct": "Service ou produit",
    "recipientEmail": "Destinataire email",
    "emailMessageOptional": "Email message (facultatif)",
    "thankYouForYourBusiness": "Thank you pour votre business",
    "documentType": "Type de document",
    "acmeSupplies10InvoiceInv1042": "Acme Supplies&#10;Facture INV-1042&#10;Total: 1,250.00&#10;Date: 2026-05-15",
    "fileName": "Nom du fichier",
    "pasteTextForExtractionOptional": "Coller le texte à extraire (facultatif)",
    "amount": "Montant",
    "reportCode": "Rapport code",
    "reportName": "Rapport name",
    "baseReport": "Base rapport",
    "includeLabelsCommaSeparatedKeywords": "Inclure les libellés (mots-clés séparés par des virgules)",
    "accountTypes": "Compte types",
    "revenueExpenseCash": "revenu, dépense, trésorerie",
    "sourceType": "Type de source",
    "totalAmount": "Montant total",
    "taxCode": "Code fiscal",
    "taxName": "Nom de la taxe",
    "selectTax": "Sélectionner une taxe",
    "workflowCode": "Flux de travail code",
    "workflowName": "Flux de travail name",
    "routing": "Routage",
    "stageName": "Nom de l'étape",
    "paymentIdToMatch": "ID du paiement à rapprocher",
    "matchAllTransactionsBeforeFinalizing": "Rapprochez toutes les transactions avant de finaliser",
    "bankFeedFormatHint": "CSV : date,description,amount[,reference] · formats de flux bancaire OFX/MT940 pris en charge",
    "bankFeedConfiguration": "Configuration du flux bancaire",
    "plaidConfigOnly": "Plaid (configuration uniquement)"
  },
  "formActions": {
    "saveAccount": "Enregistrer le compte",
    "saveDraftJournal": "Enregistrer le brouillon",
    "saveReport": "Enregistrer le rapport",
    "saveRule": "Enregistrer la règle",
    "lock": "Verrouiller",
    "reopen": "Rouvrir",
    "importCsv": "Importer CSV",
    "importOfx": "Importer OFX",
    "importMt940": "Importer MT940",
    "autoMatch": "Rapprocher automatiquement",
    "finalizing": "Finalisation…",
    "finalizeReconciliation": "Finaliser le rapprochement",
    "saveFeed": "Enregistrer le flux"
  },
  "listActions": {
    "addTax": "Ajouter une taxe",
    "createBudget": "Créer un budget",
    "startClose": "Démarrer la clôture",
    "runDunning": "Lancer les relances",
    "runRecognition": "Lancer la comptabilisation",
    "createSchedule": "Créer un échéancier",
    "createPaymentRun": "Créer un lot de paiements"
  }
}
